import { useQuery } from '@tanstack/react-query';

import { productDescriptionRawOptions } from './product-description-raw-options';

export const useGetProductDescriptionRaw = (options: ReturnType<typeof productDescriptionRawOptions>) => {
  return useQuery(options);
};
